import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=ace00d16&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ace00d16')) {
      api.createRecord('ace00d16', component.options)
    } else {
      api.reload('ace00d16', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=ace00d16&", function () {
      api.rerender('ace00d16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27yABboA4emuJ/JS/offershelp.vue"
export default component.exports